import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import { useProject } from '../projects/context';
import { projectKeys, useProjectApi } from '../projects/useProjectApi';
import { ConfirmationCall } from './ConfirmationCall';
import { fmtDateTime } from './format';
import { confirmationOpen, phoneConfirmationView } from './phoneConfirmation';
import { PhoneConfirmationActions } from './PhoneConfirmationActions';

// Lead mit anstehendem Termin in der Akquise (Thomas 16.10.2026: „ich kann nach einem gesetzten Termin immer noch nicht
// anrufen, um den Termin zu bestätigen“): Anrufen wie in der Terminbestätigung – ohne Akquise-Sperren (Termin besteht,
// Mindestabstand), nur Kontaktstopp und Anrufzeiten gelten; danach das Ergebnis eintragen.
export function UpcomingConfirmation({ appointmentId, leadId, leadName }: { appointmentId: string; leadId: string; leadName: string }) {
  const { project, can } = useProject();
  const papi = useProjectApi();
  const [now] = useState(() => new Date());
  const detail = useQuery({
    queryKey: projectKeys.appointment(project.id, appointmentId),
    queryFn: ({ signal }) => papi.appointment(appointmentId, signal),
  });
  const a = detail.data;
  if (!a || !can('call.start') || new Date(a.start_at) <= now) return null;
  const c = a.phone_confirmation;
  const view = c ? phoneConfirmationView(c, now) : null;
  return (
    <section className="upcoming-confirmation" aria-label="Termin bestätigen">
      <div className="section-head">
        <h3>Termin bestätigen</h3>
        {view && <span className={`badge badge-${view.tone}`}>{view.label}</span>}
      </div>
      <p>
        Termin am <strong>{fmtDateTime(a.start_at)}</strong>
        {a.field_sales_name && <span className="muted"> · {a.field_sales_name}</span>}
      </p>
      <p className="muted small">Hier anrufen – ohne Akquise-Sperren wie „Termin besteht“ oder Mindestabstand. Danach das Ergebnis eintragen.</p>
      {confirmationOpen(c) ? (
        <PhoneConfirmationActions appointmentId={a.id} leadId={leadId} leadName={leadName} />
      ) : (
        <ConfirmationCall appointmentId={a.id} leadId={leadId} />
      )}
    </section>
  );
}
